import { GrowIcon, SwapIcon } from '@aperture/assetkit';

export const english = {
  navbar: {
    test: 'Testnet',
    main: 'Mainnet',
    eth: 'Ethereum',
    terra: 'Terra',
    connect: {
      button: 'Connect Wallet',
      dialog: 'Select Network',
      auth: 'Login and Authorize your Wallet',
      error: 'You have dismissed the connection.',
    },
    network: {
      button: 'Network',
    },
    navLinks: {
      links: [
        { icon: GrowIcon, text: 'aperture originals', link: 'dn', disabled: false },
        { icon: SwapIcon, text: 'portfolio', link: 'portfolio', disabled: false },
      ],
    },
    soon: 'Coming soon',
    menu: 'Menu',
    popover: {
      network: {
        title: 'Switch Network',
      },
      auth: {
        // TODO: Generalize wallet type.
        connect: 'Connected with Terra Station',
        change: 'Change',
        view: 'View on explorer',
        copy: 'Copy Address',
        copied: 'Copied',
        disconnect: 'Disconnect',
        recentTitle: 'Recent Activities',
        recentText: 'Your recent transactions will appear here...',
      },
    },
    footer: {
      auditText: 'Audits',
      links: [
        { link: 'terms', text: 'terms and conditions' },
        { link: 'privacy', text: 'privacy policy' },
        { link: 'credits', text: 'credits' },
      ],
    },
  },
  banner: {
    wallet: 'Please connect your wallet!',
    hours:
      'Delta-neutral positions on synthetic stock tokens can only be opened during US market hours.',
  },
  disclaimer: {
    header: 'Disclaimer',
    text1:
      'The Aperture Finance platform, its software and all content found on it are provided on an “as is” and “as available” basis. Aperture Finance does not give any warranties, whether express or implied or statutory, as to the suitability or usability of the website, its software or any of its content. Users of the website and application are subject to the ',
    text2: 'Terms and Conditions',
    text3:
      ' on our website. None of the information on this website or software constitutes financial advice, trading advice, investment advice, or any sort of other advice. Aperture will not be liable for any loss, whether such loss is direct, indirect, special or consequential, suffered by any party as a result of their use of the Aperture platform, its software or content. Any interaction with the web-app is done at the user’s own risk, and the user will be solely responsible for any damage or loss that results from such activities. By transacting on the platform, you agree that you do not consider any of the staking options on the platform to be securities and that you are using them for your own personal utility and not for any investment purposes. Additionally, you agree that you do not consider APTs to be securities and that you understand APTs may lose all of their value and that you are not acquiring APTs for any investment purpose. Should you encounter any bugs, glitches, lack of functionality or other problems on the protocol, please let us know immediately so we can rectify them accordingly. Your help in this regard is greatly appreciated! Please share your feedback to our Discord channel',
    link: { link: 'https://discord.gg/aN8BntkzuZ', text: '#feedback.' },
    acknowledge:
      'Check the box to confirm that you have read and understood the above message.',
    confirm: 'I Agree',
  },
  actionRequired: {
    header: 'Action Required',
    text1: 'We recommend all Aperture users',
    text2: 'withdraw their $UST from the delta-neutral strategies immediately!',
    text3:
      'There are uncertainties around the underlying protocols Aperture interacts with. By staying invested in delta-neutral strategies, you are responsible for any issues, including loss of funds, arising from "non-functionality" risk from Anchor, Mirror, or Band Protocol.',
    text4:
      'Also, we believe this is the safest route to be eligible for Luna airdrops when the Terra 2.0 chain comes online.',
    confirm: 'OK',
  },
  whitelistedConnect: {
    congratulation: {
      header: 'Congratulation!',
      description: "You have gained access to Aperture's new private beta.",
      confirm: 'Enter Private Beta',
    },
    needAccess: {
      header: 'Wait, you need access first!',
      description:
        "This is Aperture's private beta. The wallet linked is not yet whitelisted. To join the whitelist follow the link below and acquire 70 XP by completing the tasks.",
      confirm: 'Join Whitelist',
    },
  },
  investment: {
    title: 'Strategy',
    portfolio: {
      title: 'portfolio',
      TVL: 'Aperture TVL (UST)',
      list: {
        total: 'total value',
        day: 'daily return',
        original: 'original value',
        historical: 'total return',
      },
    },
    tvlBox: {
      PDN: 'TVL in Leveraged Farming',
      lendingOptimizer: 'TVL in Lending Optimizer',
      total: 'Total Value Locked',
    },
    search: {
      searchBar: 'Search tokens, pool, and assets',
      popular: 'popular',
      manage: 'manage tokens',
    },
    invest: {
      PDN: {
        title: 'Leveraged Farming (Pseudo Delta Neutral)',
        mobileTitle: 'Leveraged Farming',
      },
      tableAssets: {
        investPlus: 'original',
        tooltip: {
          toolTipTitle: 'APR Breakdown',
          modalTitle: 'Yield',
          collateral: 'Collateral APR (Anchor Earn)',
          short: 'Short-farm Reward (Mirror)',
          long: 'Long-farm Reward (Mirror)',
          spec: 'SPEC APR',
          mir: 'MIR APR',
          trade: 'TerraSwap Trade APR',
          firstApr: 'APR (first 14 days)',
          afterApr: 'APR (after 14 days)',
          notes: [
            `Reward proportional to the allocation of the total amount: (Anchor APR  %{ancApr} x %{ratio} = %{ancTimesRatio} ).`,
            'Long-farm starts in 2 weeks after initiating the position.',
            'APR calculation is based on the default collateral ratio (CR); customized CR will affect the result.',
          ],
        },
      },
      filterPlus: [
        // { text: 'All', value: 1 },
      ],
      filter: [
        // { text: 'All', value: 1 },
      ],
      order: [
        { text: 'Vault' },
        { text: 'Leverage' },
        { text: 'TVL' },
        { text: 'Capacity' },
        { text: 'APY' },
        { text: 'My Holdings' },
        { text: 'Action' },
      ],
      action: 'deposit',
      show: 'Show All',
      hide: 'Hide',
      dropdown: {
        text1: 'With',
        text2:
          'as the underlying asset, this delta-neutral strategy maintains equal weights in the long-farm and short-farm positions through regular rebalance, which significantly neutralizes the volatility of the underlying asset and generates stable yields from liquidity provision. Additional features include liquidation protection, auto-compound, and atomic transactions. More details on the protocols involved in this strategy can be found below:',
        anchorText1: `Anchor Earn lends UST (TerraUSD) to the Anchor money market. Deposited TerraUSDs are pooled and lent out to borrowers, with accrued interest pro-rata distributed to all depositors.`,
        anchorText2: `Depositors receive newly minted Anchor UST (aUST) in exchange for their deposit. aUST tokens represent a depositor's share in the stablecoin pool and can later be redeemed to claim the initial UST deposit, along with accrued interest.`,
        protocols: 'Protocols',
        code: 'Code Access',
        security: 'Security Audit',
        spectrum: 'Spectrum',
        anchor: 'Anchor',
        mirror: 'Mirror',
        open: {
          anchor: 'https://github.com/Anchor-Protocol',
          mirror: 'https://github.com/Mirror-Protocol',
          spectrum: 'https://github.com/spectrumprotocol',
          text: 'Open-source',
        },
        completed: {
          anchor: 'https://docs.anchorprotocol.com/security',
          mirror: 'https://docs.mirror.finance/security',
          spectrum:
            'https://github.com/HalbornSecurity/PublicReports/blob/master/CosmWasm%20Smart%20Contract%20Audits/Spectrum_Protocol_CosmWasm_Smart_Contract_Security_Audit_Halborn_Report_v1_1.pdf',
          text: 'Completed',
        },
      },
    },
  },
  assets: {
    error:
      'Error: there’s something wrong with the network, please try again later.',
    investText: 'Deposit',
    depositText: 'Deposit',
    withdrawText: 'Withdraw',
    strategyText: 'strategy',
    tokenText: 'supply',
    supplyText: 'supply',
    detailsText: 'details',
    feeText: 'FEES AND SETTINGS',
    feeTextWithdrawl: 'FEES',
    gasText: 'Estimated Gas Fee',
    currentValueText: 'Current Value',
    nonApertureFee: 'Non-Aperture Fees',
    bridgeText: 'Bridge Processing Fee',
    strategyFeeText: 'Performance Fee',
    miniReceivedText: 'Minimum Recieved After Slippage',
    swapFeeText: 'Swap Fee from the DEX',
    feeExitText: 'Strategy Fee on Exit',
    targetText: 'Target Collateral Ratio',
    defaultCollateral: 'Default',
    apyTitle: 'Expected APY',
    apyText: 'before fees and expenses',
    max: 'max',
    partialWithdrawl:
      'Partial withdrawal is not supported for Delta-Neutral Strategy',
    fees: 'Fees',
    gasFee: 'Gas Fee',
    originalText: 'Original Value',
    grossText: 'Gross Return',
    netReturnText: 'Net Return',
    receiveText: 'You Will Receive',
    minInvest: '0.1 AVAX minimum required',
    maxBalance: 'Insufficient USDC Balance',
    maxWithdraw: 'Max withdrawl',
    reminder1: 'The price of %{pos} has to increase by ',
    reminder2:
      ' for you to get flagged for liquidation. Higher target collateral ratio can further decrease liquidation risk. Default target collateral ratio is set to %{defaultCol}% with a built-in liquidation protection mechanism.',
    warning:
      'Not leaving enough UST balance may result in insufficient fees to cover future transactions.',
    feeError: `You don't have enough balance to pay for the gas fee.`,
    hint1: 'This percentage is calculated based on your current value.',
    hint2:
      'This percentage is calculated based on your current value, which is also equal to 10% of your gross return.',
    nonApertureFeeHint1: 'Non-Aperture Fees Includes:',
    nonApertureFeeHint2: 'Mirror Fees',
    nonApertureFeeHint3: 'TerraSwap Fees',
    referTo: 'Refer to our ',
    gitbook: 'gitbook',
    moreInfo: ' for more information on fees.',
    within2WeeksHint:
      'You have invested in this Delta-Neutral Strategy for less than 2 weeks. It takes 2 weeks for DNS to achieve maximum potential APR.',
    gasFeeHint:
      'Gas Fee will be deducted from your wallet balance directly (not from the current value of your Aperture investment).',
    confirmDialogTitle: 'Do You Confirm?',
    confirmDialogContentWithdraw1:
      'You will withdraw the full amount from your %{pos} position.',
    confirmDialogContentWithdraw2:
      'You will withdraw the full amount from your %{pos} position before achieving maximum potential APR.',
    confirmDialogContentWithdraw3:
      'You will withdraw the full amount from your %{pos} position and stop earning ',
    confirmDialogBtnCancel: 'cancel withdrawal',
    confirmDialogBtnConfirm: 'confirm',
    openDeltaPosition: 'Open delta-neutral position',
    closeDeltaPosition: 'Close delta-neutral position',
  },
  portfolio: {
    title: 'Portfolio',
    total: 'Total Value',
    progress: 'in progress',
    dashboard: {
      total: 'total',
      history: 'trade history',
      value: 'total value',
      aperture: 'aperture investment',
      holdings: 'token holdings',
    },
    asset: {
      time: 'Invested at',
      apy: 'apy',
      realTimeApr: 'real-time apr',
      apr: 'your apr',
      aprHelperText:
        'Real-time APR is indicative and should not be used as a performance measure.',
      helperText:
        'Please note that Delta-neutral positions on synthetic stock tokens can only be opened or closed during US market hours.',
      history: 'trade history',
      withdraw: 'withdraw',
      invest: 'deposit',
      value: 'value',
      totalValue: 'total value',
      return: 'return',
      sevenDay: '7d return',
      thirtyDay: '30d return',
      ninetyDay: '90d return',
      original: 'original value (UST)',
      historical: 'return (UST)',
    },
    chart: {
      title: 'Historical Performance',
      day: 'day',
      month: 'month',
      year: 'year',
      not: 'not applicable',
    },
    history: {
      allTitle: 'all trade history',
      title: 'trade history',
      time: 'time',
      strategy: 'strategy',
      action: 'action',
      amount: 'amount',
    },
    overview: {
      title: 'My Portfolio',
      values: {
        total: 'Total Value',
        dnv: 'Delta-Neutral Vaults',
        lending: 'Lending Optimizer',
      },
      section: {
        pdn: 'Psudo-Delta-Neutral Strategy',
        lending: 'Lending Optimizer',
        dn: 'Delta-Neutral',
      },
      history: 'View History',
    },
    search: {
      searchBar: 'Search Assets or DEX',
    },
    reminder: {
      connectWallet: 'Connect Wallet to View Your Portfolio!',
      noPosition: "You haven't opened a position yet!",
    },
    order: [
      { text: 'Position' },
      { text: 'TVL' },
      { text: 'Capacity' },
      { text: 'My Deposit' },
      { text: 'My Holdings' },
      { text: 'Yields' },
    ],
  },
  credits: {
    title: 'Credits',
    text: 'Robots lovingly delivered by ',
    link: ['https://robohash.org/', 'Robohash.org.'],
  },
  privacy: {
    title: 'Privacy Policy',
    body: [
      { text: `Last updated: January 6, 2022`, type: 'p' },
      {
        text: `Welcome to Aperture! This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of your information when you use the Products and Service and tells you about your privacy rights and how the law protects you`,
        type: 'p',
      },
      {
        text: `We use your personal data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this Privacy Policy. Individuals in the European Economic Area and the European Free Trade Association may have additional rights as described below in the GDPR Privacy Policy.`,
        type: 'p',
      },
      { text: `Definitions`, type: 'subtitle' },
      { text: `For the purposes of this Privacy Policy:`, type: 'p' },
      {
        text: [
          {
            Account:
              'means a unique account created for you to access our Service or parts of our Service.',
          },
          {
            Company:
              '(referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Aperture, 510 C East El Camino Real #70522, Sunnyvale, CA 94087.',
          },
          {
            Cookies:
              'are small files that are placed on your computer, mobile device or any other device by a website, containing the details of your browsing history on that website among its many uses.',
          },
          { Country: 'refers to: United States.' },
          {
            Device:
              'means any device that can access the Service such as a computer, a cellphone or a digital tablet.',
          },
          {
            'Personal Data':
              'is any information that relates to an identified or identifiable individual.',
          },
          { Service: 'refers to the Website.' },
          {
            'Service Provider':
              'means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.',
          },
          {
            'Usage Data':
              'refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).',
          },
          { Website: 'refers to Aperture, accessible from aperture.finance' },
          {
            You: 'means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.',
          },
        ],
        type: 'bullets',
      },
      { text: `Types of Data Collected`, type: 'subtitle' },
      { text: `Personal Data`, type: 'subtitle' },
      {
        text: `While using Our Service, We may ask you to provide Us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to:`,
        type: 'p',
      },
      {
        text: [
          'Email address',
          'First name and last name',
          'Phone number',
          'Address, State, Province, ZIP/Postal code, City',
          'Usage Data',
        ],
        type: 'list',
      },
      { text: `Proof of Identity`, type: 'subtitle' },
      {
        text: `Exchanges or protocols that are linked or described on Aperture’s website may collect AML/KYC information such as customers’ Social Security numbers and scanned versions of government identification. Additionally, proof of address, such as a utility bill or other mortgage/lease documents may be required.`,
        type: 'p',
      },
      { text: `Additional Personal Data`, type: 'subtitle' },
      {
        text: `Our compliance team may collect certain criminal records or other records of alleged criminal liability.`,
        type: 'p',
      },
      { text: `Blockchain Data`, type: 'subtitle' },
      {
        text: `We or our partners may collect and monitor information from blockchain transactions to support AML/KYC compliance and security measures. This includes cryptocurrency wallet addresses, individual transaction volume, and transaction size.`,
        type: 'p',
      },
      { text: `Information from Contacting Us`, type: 'subtitle' },
      {
        text: `We may collect your device’s IP address, information about your use of the Site during your active session and over time (including the pages you view and the files you download), the date and time of your visit, how you interact with the Site including, links you click, searches conducted, the website visited before navigating to the Site, your software and hardware attributes (including browser and operating system type and version, device type, and your general location inferred from IP address. To obtain such information, we or our service providers may use the below described technologies.`,
        type: 'p',
      },
      { text: `Usage Data`, type: 'subtitle' },
      {
        text: `Usage Data is collected automatically when using the Service.`,
        type: 'p',
      },
      {
        text: `Usage Data may include information such as your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.`,
        type: 'p',
      },
      {
        text: `When you access the Service by or through a mobile device, we may collect certain information automatically, including, but not limited to, the type of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use, unique device identifiers and other diagnostic data.`,
        type: 'p',
      },
      {
        text: `We may also collect information that your browser sends whenever you visit our Services or when you access the Service by or through a mobile device.`,
        type: 'p',
      },
      { text: `Tracking Technologies and Cookies`, type: 'subtitle' },
      {
        text: `We use Cookies and similar tracking technologies to track the activity on Our Service and store certain information. Tracking technologies used are beacons, tags, and scripts to collect and track information and to improve and analyze Our Service. The technologies We use may include:`,
        type: 'p',
      },
      {
        text: [
          {
            'Server Logs.':
              'We may use server logs to automatically receive and record data from your computer or device and browser.',
          },
          {
            'Cookies or Browser Cookies.':
              'A cookie is a small file placed on your Device. you can instruct your browser to refuse all Cookies or to indicate when a Cookie is being sent. However, if you do not accept Cookies, you may not be able to use some parts of our Service. Unless you have adjusted your browser setting so that it will refuse Cookies, our Service may use Cookies.',
          },
          {
            'Web Beacons.':
              'Certain sections of our Service and our emails may contain small electronic files known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel gifs) that permit the Company, for example, to count users who have visited those pages or opened an email and for other related website statistics (for example, recording the popularity of a certain section and verifying system and server integrity).',
          },
          {
            'Flash Cookies.': `Certain features of our Service may use local stored objects (or Flash Cookies) to collect and store information about your preferences or your activity on our Service. Flash Cookies are not managed by the same browser settings as those used for Browser Cookies. For more information on how you can delete Flash Cookies, please read "Where can I change the settings for disabling, or deleting local shared objects?" available at `,
          },
          {
            link: 'https://helpx.adobe.com/flash-player/kb/disable-local-shared-objects-flash.html#main_Where_can_I_change_the_settings_for_disabling__or_deleting_local_shared_objects_',
          },
        ],
        type: 'bullets',
      },
      {
        text: `Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies remain on your personal computer or mobile device when you go offline, while Session Cookies are deleted as soon as you close your web browser.`,
        type: 'p',
      },
      {
        text: `We use both Session and Persistent Cookies for the purposes set out below:`,
        type: 'p',
      },
      { text: `Necessary / Essential Cookies`, type: 'subtitle' },
      { text: `Type: Session Cookies`, type: 'p' },
      { text: `Administered by: Us`, type: 'p' },
      {
        text: `Purpose: These Cookies are essential to provide you with services available through the Website and to enable you to use some of its features. They help to authenticate users and prevent fraudulent use of user accounts. Without these Cookies, the services that you have asked for cannot be provided, and We only use these Cookies to provide you with those services.`,
        type: 'p',
      },
      { text: `Cookies Policy / Notice Acceptance Cookies`, type: 'subtitle' },
      { text: `Type: Persistent Cookies`, type: 'p' },
      { text: `Administered by: Us`, type: 'p' },
      {
        text: `Purpose: These Cookies identify if users have accepted the use of cookies on the Website.`,
        type: 'p',
      },
      { text: `Functionality Cookies`, type: 'subtitle' },
      { text: `Type: Persistent Cookies`, type: 'p' },
      { text: `Administered by: Us`, type: 'p' },
      {
        text: `Purpose: These Cookies allow us to remember choices you make when you use the Website, such as remembering your login details or language preference. The purpose of these Cookies is to provide you with a more personal experience and to avoid you having to re-enter your preferences every time you use the Website.`,
        type: 'p',
      },
      {
        text: `For more information about the cookies we use and your choices regarding cookies, please visit our Cookies Policy or the Cookies section of our Privacy Policy.`,
        type: 'p',
      },
      { text: `Use of your Personal Data`, type: 'subtitle' },
      {
        text: `The Company may use Personal Data for the following purposes:`,
        type: 'p',
      },
      {
        text: [
          {
            'To provide and maintain our Service':
              ', including to monitor the usage of our Service.',
          },
          {
            'To manage your Account:':
              'to manage your registration as a user of the Service. The Personal Data you provide can give you access to different functionalities of the Service that are available to you as a registered user.',
          },
          {
            'To verify your identity:':
              ' To comply with legal obligations and other regulations or statutes, we may share your information with vendors or other parties. We may also conduct diligence checks under applicable laws or regulations or other agreements.',
          },
          {
            'For the performance of a contract:':
              'the development, compliance and undertaking of the purchase contract for the products, items or services you have purchased or of any other contract with us through the Service.',
          },
          {
            'To contact you:': `To contact you by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation.`,
          },
          {
            'To provide you':
              'with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless you have opted not to receive such information.',
          },
          {
            'To manage your requests:':
              'To attend and manage your requests to us.',
          },
          {
            'For business transfers:':
              'We may use your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by us about our Service users is among the assets transferred.',
          },
          {
            'For other purposes':
              ': We may use your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience.',
          },
        ],
        type: 'bullets',
      },
      {
        text: `We may share your personal information in the following situations:`,
        type: 'p',
      },
      {
        text: [
          {
            'With Service Providers:':
              'We may share your personal information with Service Providers to monitor and analyze the use of our Service, to contact you.',
          },
          {
            'Third-party plug-ins:':
              ' Third-party plug-ins such as Facebook or Twitter may collect information about you even if you do not click the buttons, including IP address and other pages you view. Please visit their websites for full information on their privacy polices.',
          },
          {
            'For business transfers:':
              'We may share or transfer your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business to another company.',
          },
          {
            'With Affiliates:':
              'We may share your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other subsidiaries, joint venture partners or other companies that We control or that are under common control with Us.',
          },
          {
            'With business partners:':
              'We may share your information with Our business partners to offer you certain products, services or promotions.',
          },
          {
            'With other users:':
              'when you share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside.',
          },
          {
            'With your consent':
              ': We may disclose your personal information for any other purpose with your consent.',
          },
        ],
        type: 'bullets',
      },
      {
        text: `Cryptocurrency assets and protocols such as Bitcoin, Ethereum, and other tokens and stablecoins are not truly anonymous since information can often by traced from a public wallet address to you in certain ways. We may track and keep data for compliance and other purposes that may stem from these publicly accessible sources.`,
        type: 'p',
      },
      { text: `Retention of your Personal Data`, type: 'subtitle' },
      {
        text: `The Company will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.`,
        type: 'p',
      },
      {
        text: `The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or we are legally obligated to retain this data for longer time periods.`,
        type: 'p',
      },
      { text: `Transfer of your Personal Data`, type: 'subtitle' },
      {
        text: `Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction.`,
        type: 'p',
      },
      {
        text: `Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.`,
        type: 'p',
      },
      {
        text: `The Company will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of your data and other personal information.`,
        type: 'p',
      },
      { text: `Disclosure of your Personal Data`, type: 'subtitle' },
      { text: `Business Transactions`, type: 'subtitle' },
      {
        text: `If the Company is involved in a merger, acquisition or asset sale, your Personal Data may be transferred. We will provide notice before your Personal Data is transferred and becomes subject to a different Privacy Policy.`,
        type: 'p',
      },
      { text: `Law enforcement`, type: 'subtitle' },
      {
        text: `Under certain circumstances, the Company may be required to disclose your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).`,
        type: 'p',
      },
      { text: `Other legal requirements`, type: 'subtitle' },
      {
        text: `The Company may disclose your Personal Data in the good faith belief that such action is necessary to:`,
        type: 'p',
      },
      {
        text: [
          'Comply with a legal obligation',
          'Protect and defend the rights or property of the Company',
          'Prevent or investigate possible wrongdoing in connection with the Service',
          'Protect the personal safety of Users of the Service or the public',
          'Protect against legal liability',
        ],
        type: 'list',
      },
      { text: `Security of your Personal Data`, type: 'subtitle' },
      {
        text: `The security of your Personal Data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.`,
        type: 'p',
      },
      { text: `Children's Privacy`, type: 'h2' },
      {
        text: `Our Service is prohibited for use by anyone under the age of 18. We do not knowingly collect personally identifiable information from anyone under the age of 18. If you are a parent or guardian and you are aware that your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 18 without verification of parental consent, we take steps to remove that information from Our servers.`,
        type: 'p',
      },
      {
        text: `If We need to rely on consent as a legal basis for processing your information and your country requires consent from a parent, we may require your parent's consent before we collect and use that information.`,
        type: 'p',
      },
      { text: `Links to Other Websites`, type: 'h2' },
      {
        text: `Our Service may contain links to other websites that are not operated by Us. If you click on a third-party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.`,
        type: 'p',
      },
      {
        text: `We have no control over and assume no responsibility for the content, privacy policies or practices of any third-party sites or services.`,
        type: 'p',
      },
      { text: `Changes to this Privacy Policy`, type: 'h2' },
      {
        text: `We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.`,
        type: 'p',
      },
      {
        text: `We will let you know via email and/or a prominent notice on our Site, prior to the change becoming effective and update the "Last updated" date at the top of this Privacy Policy.`,
        type: 'p',
      },
      {
        text: `You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.`,
        type: 'p',
      },
      { text: `Contact Us`, type: 'h2' },
      {
        text: `If you have any questions about this Privacy Policy, you can contact us:`,
        type: 'p',
      },
      { text: `By email: privacy@aperture.finance`, type: 'p' },
      {
        text: `GDPR Privacy Policy (not applicable to non-EU Data Subjects)`,
        type: 'h2',
      },
      {
        text: `The General Data Protection Regulation (“GDPR”) (Regulation (EU) 2016/679) provides certain rights in favor of data subjects domiciled in the European Union (“EU”). The rights in question are as follows (the “Data Subject Rights”):`,
        type: 'p',
      },
      {
        text: [
          'the right of a data subject to receive detailed information on the processing (by virtue of the transparency obligations on GMO);',
          'the right of access to personal data;',
          'the right to amend and rectify any inaccuracies in personal data;',
          'the right to erase personal data (right to be forgotten);',
          'the right of data portability;',
          'the right to restrict Processing;',
          'the right to object to Processing; and',
          'the right to object to automated decision making, including profiling.',
        ],
        type: 'list',
      },
      {
        text: `Aperture may not be able to discharge these rights in certain circumstances (e.g., because of the nature of the relationship between Aperture and the customer). Data subjects may make a request exercise any of the Data Subject Rights by contacting privacy@aperture.finance. Requests shall be dealt with in accordance with relevant data protection laws.`,
        type: 'p',
      },
      {
        text: `Aperture is a data controller within the meaning of the GDPR and will treat any relevant personal data provided by customers in confidence and in accordance with relevant data protection legislation. Please direct any questions about how Aperture uses customers’ personal data to privacy@aperture.finance.`,
        type: 'p',
      },
    ],
  },
  terms: {
    title: 'User Agreement and Terms of Use',
    body: [
      { text: `User Agreement and Terms of Use`, type: 'p' },
      {
        text: `Welcome to Aperture! This is a User Agreement between you (also referred to herein as “Client,” “User,” or customer) and Aperture pertaining to purchase, acquisition, and use of its software and app. This User Agreement ("Agreement") governs your use of the services, technologies, or products provided by Aperture Portal Ltd ("Aperture Services" or "Services"). By using the Services, you agree that you have read, understand, and accept all of the terms and conditions contained in these Terms including Section 8. "Arbitration; Waiver of Class Action", as well as our Privacy Policy.`,
        type: 'p',
      },
      {
        text: `As with any asset, the value of Digital Currencies can go up or down and there can be a substantial risk that you lose money buying, selling, holding, or investing in digital currencies. You should carefully consider whether trading or holding Digital Currencies is suitable for you in light of your financial condition. Aperture is not registered with the U.S. Securities and Exchange Commission and does not offer securities services in the United States or to U.S. persons. Additionally, this is not a solicitation for investment.`,
        type: 'p',
      },
      {
        text: `PLEASE READ THE FOLLOWING TERMS CAREFULLY FOR APERTURE’S SERVICES. THERE ARE RISKS ASSOCIATED WITH THE VALUE OF CRYPTOGRAPHIC TOKENS, STABLECOINS, AND BLOCKCHAIN-BASED TECHNOLOGIES. IT IS ADVISABLE THAT ONLY THOSE WELL-VERSED IN THESE TECHNOLOGIES CHOOSE TO PURCHASE OR STAKE TOKENS. PURSUANT TO BELOW SECTIONS, USERS AGREE TO VARIOUS DISCLAIMERS. THIRD-PARTY WEBSITES, SUCH AS THE DECENTRALIZED FINANCE (“DEFI”) PROTOCOLS APPEARING ON APERTURE’S SERVICES, MAY HAVE ADDITIONAL TERMS OF SERVICE THAT APPLY. USE OF THIS SITE AND THESE TECHNOLOGIES IS ENTIRELY AT YOUR OWN RISK.`,
        type: 'upper',
      },
      {
        text: `PLEASE BE AWARE THAT SECTION 8 OF THESE TERMS, BELOW, CONTAINS PROVISIONS GOVERNING HOW CLAIMS THAT YOU AND WE HAVE AGAINST EACH OTHER ARE RESOLVED, INCLUDING, WITHOUT LIMITATION, ANY CLAIMS THAT AROSE OR WERE ASSERTED PRIOR TO THE EFFECTIVE DATE OF THESE TERMS. IN PARTICULAR, IT CONTAINS AN ARBITRATION AGREEMENT WHICH WILL, WITH LIMITED EXCEPTIONS, REQUIRE DISPUTES BETWEEN US TO BE SUBMITTED TO BINDING AND FINAL ARBITRATION. UNLESS YOU OPT OUT OF THE ARBITRATION AGREEMENT: (1) YOU WILL ONLY BE PERMITTED TO PURSUE CLAIMS AND SEEK RELIEF AGAINST US ON AN INDIVIDUAL BASIS, NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY CLASS OR REPRESENTATIVE ACTION OR PROCEEDING; AND (2) YOU ARE WAIVING YOUR RIGHT TO SEEK RELIEF IN A COURT OF LAW AND TO HAVE A JURY TRIAL ON YOUR CLAIMS.`,
        type: 'upper',
      },
      {
        text: `ANY DISPUTE OR CLAIM RELATING IN ANY WAY TO YOUR USE OF THE SITE WILL BE GOVERNED AND INTERPRETED BY AND UNDER THE LAWS OF DELAWARE, WITHOUT GIVING EFFECT TO ANY PRINCIPLES THAT PROVIDE FOR THE APPLICATION OF THE LAW OF ANY OTHER JURISDICTION.`,
        type: 'upper',
      },
      { text: `1. Overview of Products and Services`, type: 'subtitle' },
      {
        text: `1.1 Aperture’s DeFi Yield Aggregator “Invest” and “Invest +”`,
        type: 'p',
      },
      {
        text: `Aperture’s service and software “Invest” displays a collection of various DeFi yield protocols that includes objective data about the protocols, such as the yield percentages and the auditing they conduct in addition to other factors that may be helpful to someone assessing the risk of a potential investment in a DeFi protocol. Aperture does not independently verify the information provided by these platforms and protocols. IT IS THE USER’S REPSONSIBILITY TO VERIFY THIS INFORMATION DIRECTLY WITH THE PLATFORM OR PROTOCOL.`,
        type: 'p',
      },
      {
        text: `“Invest +” offers similar functionality to “Invest” but also features a marketplace that aims to identify delta-neutral strategies on tokens and yield optimization and more.`,
        type: 'p',
      },
      { text: `1.2 APT Token`, type: 'p' },
      {
        text: `Aperture aims to launch the Aperture Token (“APT”), which will serve as a utility token for transacting on the Aperture decentralized ecosystem, including generating of yield for token stakers and serving as the governance token.`,
        type: 'p',
      },
      { text: `1.3 Exclusion of Supplemental Protocols`, type: 'p' },
      {
        text: `Unless explicitly announced on the Aperture Site or other official public statement of Aperture, supported digital currencies exclude all other protocols and/or functionality which supplement or interact with the supported digital currencies and platforms. This exclusion includes but is not limited to: metacoins, colored coins, side chains, or other derivative, enhanced, or forked protocols, tokens, or coins or other functionality, such as staking, protocol governance, and/or any smart contract functionality, which may supplement or interact with any of protocols listed. Any attempted transactions in such items may result in loss of the tokens or other losses. You acknowledge and agree that supplemental protocols are excluded from the supported digital currencies and that Aperture has no liability for any losses related to supplemental protocols.`,
        type: 'p',
      },
      { text: `1.4 Operation of Digital Currency Protocols.`, type: 'p' },
      {
        text: `We do not own or control the underlying software protocols which govern the operation of digital currency supported on our platform. Generally, the underlying protocols are open source, and anyone can use, copy, modify, and distribute them. We assume no responsibility for the operation of the underlying protocols and we are not able to guarantee the functionality, security, or transaction economics of network operations. In particular, the underlying protocols may be subject to sudden changes in operating rules (including “forks”). Any such material operating changes may materially affect the availability, value, functionality, and/or the name of the digital currencies you transact or own. Aperture does not control the timing and features of these material operating changes. It is your responsibility to make yourself aware of upcoming operating changes and you must carefully consider publicly available information and information that may be provided by Aperture in determining whether to continue to use services provided by Aperture for the affected digital currency. In the event of any such operational change, Aperture reserves the right to takes such steps as may be necessary to protect the security and safety of transactions on the platform, including temporarily removing the involved digital currency(ies) from its website, and other necessary steps; Aperture will use its best efforts to provide you notice of its response to any material operating change; however, such changes are outside of Aperture’s control and may occur without notice to Aperture. Aperture’s response to any material operating change is subject to its sole discretion and includes deciding not to support any new digital currency, fork, or other actions. You acknowledge and accept the risks of operating changes to digital currency protocols and agree that Aperture is not responsible for such operating changes and not liable for any loss of value you may experience as a result of such changes in operating rules. You acknowledge and accept that Aperture has sole discretion to determine its response to any operating change and that we have no responsibility to assist you with unsupported currencies or protocols.`,
        type: 'p',
      },
      { text: `1.5 Other Risks`, type: 'p' },
      {
        text: `Aperture aims to provide a seamless experience, but there is always risk that the mechanics or technology could glitch or function incorrectly in a way that causes the website to display incorrect or outdated information.`,
        type: 'p',
      },
      {
        text: `Trading of cryptographic tokens or stablecoins may result in substantial losses in a short period of time. Additionally, transactions may be irreversible so losses from trading, incorrect wallet address input, or inadvertent transactions may be not recoverable. Aperture disclaims all liability for these types of incidents. Cryptographic tokens and stablecoins are also a target for fraud and hacking, and Aperture also disclaims any liability for losses from such activity.`,
        type: 'p',
      },
      { text: `1.6 Upgrades`, type: 'p' },
      {
        text: `Aperture’s software and services will require routine maintenance and upgrades. You agree to allow Aperture or any entity designated by Aperture to alter aspects of its website or software on an ongoing basis and understand that routine maintenance may make the website unavailable at times.`,
        type: 'p',
      },
      { text: `1.7 Variability of Yields`, type: 'p' },
      {
        text: `The protocols and affiliated tokens generate yields from users based on investing collateral in a DeFi yield protocol. Because DeFi yields can vary, these yield rates from holding these tokens may also vary.`,
        type: 'p',
      },
      { text: `1.8 Delegation`, type: 'p' },
      {
        text: `Aperture retains the right to abdicate or delegate governance, design, and maintenance of its services and website. In the event that governance and upkeep of these stablecoins and tokens is transferred to a DAO, you agree that Aperture will not be liable for any decisions or actions taken by the DAO. Additionally, you agree to indemnify Aperture and all employees or contractors of Aperture in this case.`,
        type: 'p',
      },
      {
        text: `2. Payment and Right To Discontinue Services`,
        type: 'subtitle',
      },
      { text: `Freezes and Upgrades`, type: 'italic' },
      {
        text: `Aperture reserves the right to freeze and upgrade protocols or tokens on an aggregate level. Aperture plans to only use this ability in limited circumstances and will make commercially reasonable efforts to notify of any such changes in advance and their consequences.`,
        type: 'p',
      },
      { text: `Discontinuation of Services`, type: 'italic' },
      {
        text: `Aperture may decide to discontinue the services in response to unforeseen circumstances beyond Aperture’s control or to comply with a legal requirement.`,
        type: 'p',
      },
      { text: `3. Licenses`, type: 'subtitle' },
      { text: `Limited License`, type: 'italic' },
      {
        text: `Subject to your complete and ongoing compliance with these Terms and any applicable Purchase Terms, Aperture grants you a limited, non-exclusive, non-transferable, non-sublicensable, revocable license to access and use its Site and Services.`,
        type: 'p',
      },
      { text: `License Restrictions`, type: 'italic' },
      {
        text: `Except and solely to the extent such a restriction is impermissible under applicable law, you may not: (i) reproduce, distribute, publicly display, or publicly perform the Site; or (ii) make modifications to the Site.`,
        type: 'p',
      },
      { text: `Information You Submit`, type: 'italic' },
      {
        text: `You WILL NOT submit any information or other materials that you consider confidential or proprietary through the Site. If you choose to provide input and suggestions regarding us, our products or services, or problems with or proposed modifications or improvements to the Site ("Feedback"), then you do so on a non-confidential basis (regardless of any designation or indication to the contrary in the submitted information or any accompanying correspondence). Any Feedback may become public information that may appear in public search results. You hereby grant Aperture an unrestricted, perpetual, irrevocable, non-exclusive, fully-paid, royalty-free, transferable, sublicensable right to use, reproduce, modify, adapt, publish, distribute, translate, communicate to the public, create derivative works from, perform, display and otherwise exploit the Feedback in any manner and for any purpose, without any restrictions or compensation, including to improve the Site and create other products and services.`,
        type: 'p',
      },
      { text: `Data Collection Restrictions`, type: 'italic' },
      {
        text: `Without our prior written consent, you may not: (i) use any automated means to access the Site or collect any information from the Site (including, without limitation, data mining tools, robots, spiders, scripts or other automatic devices or programs); (ii) place pop-up windows over the Site's pages, or otherwise affect the display of this Site's pages; (iii) engage in the practices of "screen scraping", "database scraping" or any other activity with the purpose of obtaining content or other information; (iv) upload, post, email, transmit or otherwise make available any unsolicited or unauthorized advertising, promotional materials, "junk mail", "spam", "chain letters", "pyramid schemes" or any other form of commercial or non-commercial solicitation or bulk communications of any kind to any Aperture member or third party; (v) use data provided by Aperture, provided in any manner whatsoever, for any competing uses or purposes; or (vi) use the Site in any manner that violates applicable law or that could damage, disable, overburden, or impair the Site or interfere with any other party's use and enjoyment of the Site or Services.`,
        type: 'p',
      },
      { text: `Ownership; Proprietary Rights`, type: 'italic' },
      {
        text: `The Site is owned and operated by Aperture. The visual interfaces, graphics, design, compilation, information, data, computer code (including source code or object code), products, software, services and all other elements of the Site ("Materials") provided by Aperture are protected by intellectual property and other laws. All Materials included in the Site are the property of Aperture or its third-party licensors. Except as expressly authorized by Aperture, you may not copy, modify, upload, post, transmit, distribute or otherwise make use of the Materials. Aperture reserves all rights in and to the Materials not granted expressly in these Terms. Unauthorized use constitutes copyright and/or trademark infringement. You may not use any part of the Site to create a similar or competing platform. Any use of the Site not specifically permitted by these Terms is prohibited and constitutes a breach of these Terms.`,
        type: 'p',
      },
      { text: `Third-Party Services and Linked Websites`, type: 'italic' },
      {
        text: `Following the links listed on Aperture’s website and services or independently finding the websites to engage in staking may lead to cryptocurrency exchanges not owned, operated or affiliated with Aperture. Aperture is not responsible for any loss, fraud, or other damages from using these services. Users should exercise caution and determine the legitimacy of any exchange or wallet or protocol before making a purchase or using it.`,
        type: 'p',
      },
      {
        text: `If you operate a cryptocurrency exchange or protocol and wish to list your protocol for trading, please contact contact@aperture.finance to learn more.`,
        type: 'p',
      },
      {
        text: `Aperture disclaims third-party services, exchanges, or functionality, including the third-party websites that connect to a wallet containing digital currency or tokens, algorithm developers, and other service providers. Linked websites or third-party functionality are not under Aperture’s control, and Aperture is not responsible for their content or any interaction you have with them. Aperture may provide tools through the Site that enable you to export information to third-party services. By using one of these tools, you agree that Aperture may transfer that information to the applicable third-party service. Third-party services are not under Aperture’s control, and, to the fullest extent permitted by law, Aperture is not responsible for any third-party service's use of your exported information. By using Aperture’s Site and related Services, you acknowledge the risk that the third-party services and websites you use with Aperture may be vulnerable to hacking or phishing attacks, such as but not limited to spoofed portals or displays of sites or extensions like Metamask, Uniswap, or Sushiswap, and you further agree to not hold Aperture liable for any damages or harm caused by using the Aperture Site or Services with a compromised, hacked, or spoofed version of any third-party service, platform, extension, or website.`,
        type: 'p',
      },
      { text: `4. Prohibited Conduct`, type: 'subtitle' },
      {
        text: `By using the Site and/or Services you agree not to:`,
        type: 'p',
      },
      {
        text: `A. Use the Site or Services for any illegal purpose or in violation of any local, state, national, or international law, including securities and commodities laws, which general prohibit conduct such as market manipulation, spoofing, front-running, and insider trading;`,
        type: 'p',
      },
      {
        text: `B. Violate, or encourage others to violate, any right of a third party, including by infringing or misappropriating any third-party intellectual property right;`,
        type: 'p',
      },
      {
        text: `C. Upload, post, transmit, share, store or otherwise make available content that would constitute, encourage or provide instructions for a criminal offense, violate the rights of any party, or that would otherwise create liability or violate any local, state, national or international law;`,
        type: 'p',
      },
      {
        text: `D. Interfere with security-related features of the Site or Services, including by: (i) disabling or circumventing features that prevent or limit use or copying of any content; or (ii) reverse engineering or otherwise attempting to discover the source code of any portion of the Site except to the extent that the activity is expressly permitted by applicable law;`,
        type: 'p',
      },
      {
        text: `E. Interfere with the operation of the Site or Services or any user's enjoyment of the Site or Services, including by uploading or otherwise disseminating any virus, adware, spyware, worm, or other malicious or tracking computer code; or interfering with or disrupting any network, equipment, or server connected to or used to provide the Site or Services;`,
        type: 'p',
      },
      {
        text: `F. Perform any fraudulent activity including impersonating any person or entity, claiming a false affiliation, or accessing any other Site or Service without permission;`,
        type: 'p',
      },
      {
        text: `G. Sell or otherwise transfer the access granted under these Terms or any Materials (as defined in Section 3 or any right or ability to view, access, or use any Materials;`,
        type: 'p',
      },
      {
        text: `H. Attempt to do any of the acts described in this Section 4 or assist or permit any person in engaging in any of the acts described in this Section 4;`,
        type: 'p',
      },
      {
        text: `I. Use or attempt to use another's account, service or system without authorization from that person and Aperture;`,
        type: 'p',
      },
      {
        text: `J. Upload, post, transmit or otherwise make available any content that we deem to be unlawful, infringing, libelous, inflammatory, hateful, intentionally false, abusive, vulgar, obscene, threatening or harassing, discriminatory or racially, ethnically or otherwise objectionable;`,
        type: 'p',
      },
      {
        text: `K. Intimidate or harass another user of the Site or Services;`,
        type: 'p',
      },
      {
        text: `L. Collect, use or transfer any personal, private or confidential information about another person obtained from the Site;`,
        type: 'p',
      },
      {
        text: `M. Use the Site or Services for any improper purpose; and/or`,
        type: 'p',
      },
      {
        text: `N. Upload, post, transmit, share or otherwise make available any unsolicited or unauthorized advertising, solicitations or promotional materials, or engage in any other form of solicitation.`,
        type: 'p',
      },
      { text: `5. Disclaimers`, type: 'subtitle' },
      { text: `Disclaimers; Third Parties`, type: 'p' },
      {
        text: `You expressly agree and disclaim that Aperture is not responsible if third parties’ activities or use of the Site or Tokens otherwise results in a loss of tokens, value, or money.`,
        type: 'p',
      },
      { text: `Disclaimers; No Warranties`, type: 'p' },
      {
        text: `THE SITE AND ALL MATERIALS AND CONTENT AVAILABLE THROUGH THE SITE ARE PROVIDED "AS IS" AND ON AN "AS AVAILABLE" BASIS. APERTURE DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, RELATING TO THE SITE AND ALL MATERIALS AND CONTENT AVAILABLE THROUGH THE SITE, INCLUDING: (A) ANY IMPLIED WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, QUIET ENJOYMENT, OR NON-INFRINGEMENT; AND (B) ANY WARRANTY ARISING OUT OF COURSE OF DEALING, USAGE, OR TRADE. APERTURE DOES NOT WARRANT THAT THE SITE OR ANY PORTION OF THE SITE OR SERVICES, OR ANY MATERIALS OR CONTENT OFFERED THROUGH THE SITE OR SERVICES, WILL BE UNINTERRUPTED, SECURE, OR FREE OF ERRORS, VIRUSES, OR OTHER HARMFUL COMPONENTS, AND SITE DOES NOT WARRANT THAT ANY OF THOSE ISSUES WILL BE CORRECTED.`,
        type: 'p',
      },
      {
        text: `NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM THE SITE OR APERTURE ENTITIES OR ANY MATERIALS OR CONTENT AVAILABLE ON OR THROUGH THE SITE WILL CREATE ANY WARRANTY REGARDING ANY OF THE APERTURE ENTITIES. WE ARE NOT RESPONSIBLE FOR ANY DAMAGE THAT MAY RESULT FROM THE SITE OR SERVICES OR YOUR USE OF THE SITE OR SERVICES. YOU UNDERSTAND AND AGREE THAT YOU USE ANY PORTION OF THE SITE AT YOUR OWN DISCRETION AND RISK, AND THAT WE ARE NOT RESPONSIBLE FOR ANY DAMAGE TO YOUR PROPERTY (INCLUDING YOUR COMPUTER SYSTEM OR MOBILE DEVICE USED IN CONNECTION WITH THE SITE) OR ANY LOSS OF DATA.`,
        type: 'p',
      },
      {
        text: `THE LIMITATIONS, EXCLUSIONS AND DISCLAIMERS IN THIS SECTION APPLY TO THE FULLEST EXTENT PERMITTED BY LAW. Aperture does not disclaim any warranty or other right that Aperture is prohibited from disclaiming under applicable law.`,
        type: 'p',
      },
      { text: `Indemnity`, type: 'italic' },
      {
        text: `To the fullest extent permitted by law, you are responsible for your use of the Site and Services, and you will defend and indemnify Aperture and its officers, directors, employees, consultants, affiliates, subsidiaries and agents (together, the "Aperture Entities") from and against every claim brought by a third party, and any related liability, damage, loss, and expense, including reasonable attorneys' fees and costs, arising out of or connected with: (a) your unauthorized use of, or misuse of, the Site or Services; (b) your violation of any portion of these Terms, any representation, warranty, or agreement referenced in these Terms, or any applicable law or regulation; (c) your violation of any third party right, including any intellectual property right or publicity, confidentiality, other property, or privacy right; or (d) any dispute or issue between you and any third party; provided, however, that the indemnity provided in this paragraph WILL not extend to any claims or related liabilities, losses, damages or expenses under the U.S. federal or state securities laws. We reserve the right, at our own expense, to assume the exclusive defense and control of any matter otherwise subject to indemnification by you (without limiting your indemnification obligations with respect to that matter), and in that case, you agree to cooperate with our defense of those claims.`,
        type: 'p',
      },
      {
        text: `Service Interruptions and other Contingencies Disclaimer`,
        type: 'p',
      },
      {
        text: `Use of the Site and Services is made available at Aperture’s sole discretion and, as described above, provided “as is” and on an “as available” basis. Certain features and information provided as a result thereof may be subject to various factors (“Contingencies”) that impact the features’ speed, availability, accuracy, and/or functionality. Such factors may include: network congestion (including congestion on the Ethereum blockchain), failures in block propagation, corrupted blockchain data and/ or chain splits, network downtime, information from “uncle” blocks, exchange rate volatility, software bugs or other issues relating to the Site or Services, other “force majeure” conditions beyond Aperture’s control, and so on.`,
        type: 'p',
      },
      {
        text: `“Force majeure” conditions include, without limitation, acts of God; earthquakes; fires; floods; wars; civil or military disturbances; acts of terrorism; sabotage; strikes; pandemics, epidemics, and public health crises; riots; power failures; computer failure and any such circumstances beyond its reasonable control as may cause interruption, loss or malfunction of utility, transportation, computer (hardware or software) or telephone communication service; accidents; labor disputes; acts of civil or military authority; governmental actions, and so on. Notwithstanding the foregoing, in the event of such an occurrence, Aperture agrees to make a good faith effort to continue its site and services and/or resume services as soon as is reasonably possible.`,
        type: 'p',
      },
      {
        text: `Such Contingencies may at times result in interruption of services, presentation of data that is faulty or inaccurate during the time that such Contingency affects the services, slower service speed, unavailability or downtime of service(s), interruptions in blockchain data flow, and other technical interruptions and malfunctions. In some cases such Contingencies could result in loss of user funds or trading opportunities.`,
        type: 'p',
      },
      {
        text: `Your use of any Aperture Services expressly acknowledges the possibility of these Contingencies and, by agreeing to use any of these services, you agree to solely assume the risk of any such Contingencies and to indemnity and hold harmless Aperture, and/or its affiliates, from any losses associated with any such Contingencies.`,
        type: 'p',
      },
      { text: `Limitation of Liability`, type: 'p' },
      {
        text: `EXCEPT IN JURISDICTIONS WHERE SUCH PROVISIONS ARE RESTRICTED AND EXCEPT AS MAY BE REQUIRED BY APPLICABLE SECURITIES LAWS, IN NO EVENT WILL APERTURE, ITS AFFILIATES OR THEIR DIRECTORS, MANAGERS, OFFICERS, STOCKHOLDERS, MEMBERS, PARTNERS, EMPLOYEES OR REPRESENTATIVES BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL OR PUNITIVE DAMAGES, INCLUDING FOR ANY LOST PROFITS OR LOST DATA ARISING FROM YOUR USE OF THE SITE OR THE SERVICES OR ANY OF THE SITE CONTENT OR OTHER MATERIALS ON OR ACCESSED THROUGH THE SITE, WHETHER BASED ON WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE), STATUTE, OR ANY OTHER LEGAL THEORY, EVEN IF APERTURE IS AWARE OR HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.`,
        type: 'p',
      },
      {
        text: `NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, EXCEPT AS MAY BE REQUIRED BY APPLICABLE SECURITIES LAW OR OTHER LAWS, YOU WILL BE LIMITED TO INJUNCTIVE RELIEF ONLY, AND WILL NOT BE ENTITLED TO DAMAGES OF ANY KIND FROM APERTURE, ITS AFFILIATES OR THEIR DIRECTORS, MANAGERS, OFFICERS, STOCKHOLDERS , MEMBERS , PARTNERS, EMPLOYEES, OR REPRESENTATIVES, REGARDLESS OF THE CAUSE OF ACTION.`,
        type: 'p',
      },
      {
        text: `EACH PROVISION OF THESE TERMS THAT PROVIDES FOR A LIMITATION OF LIABILITY, DISCLAIMER OF WARRANTIES, OR EXCLUSION OF DAMAGES IS INTENDED TO AND DOES ALLOCATE THE RISKS BETWEEN THE PARTIES UNDER THESE TERMS. THIS ALLOCATION IS AN ESSENTIAL ELEMENT OF THE BASIS OF THE BARGAIN BETWEEN THE PARTIES. EACH OF THESE PROVISIONS IS SEVERABLE AND INDEPENDENT OF ALL OTHER PROVISIONS OF THESE TERMS. THE LIMITATIONS IN THIS SECTION WILL APPLY EVEN IF ANY LIMITED REMEDY FAILS OF ITS ESSENTIAL PURPOSE.`,
        type: 'p',
      },
      {
        text: `CERTAIN FEDERAL AND STATE LAWS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF CERTAIN DAMAGES OR LIMITATIONS ON IMPLIED WARRANTIES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE DISCLAIMERS, EXCLUSIONS OR LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MAY HAVE ADDITIONAL RIGHTS.`,
        type: 'p',
      },
      { text: `6. No Financial Advice`, type: 'subtitle' },
      {
        text: `Aperture and the Site and Services do not provide any financial opinions or advice. All content on the Site is for informational purposes only and should not be taken as investment advice. Use of the information provided on the Site for any financial decisions is solely at your discretion and at your own risk. Aperture assumes no responsibility and makes no claims regarding the information on the Site, except as otherwise set forth herein.`,
        type: 'p',
      },
      {
        text: `Unless specifically indicated otherwise, none of the information available through any portion of the Site is an offer to buy or sell, or an attempt to solicit the buying or selling of, any investment products or other financial product or service, an official confirmation of any transaction, or an attempt to provide any investment recommendation, advice, or service. Further, no information available on the Site constitutes financial, legal, or tax advice.`,
        type: 'p',
      },
      {
        text: `Decisions to buy, sell, hold or trade in securities, commodities, or other investments involve risk and are typically best made based on the advice of qualified financial professionals. Any trading in securities or other investments involves a risk of substantial losses. Before undertaking any transaction or trading, you should consult a qualified financial professional. Please consider carefully whether such trading is suitable for you in light of your financial condition and ability to bear financial risks. Under no circumstances shall we be liable for any loss or damage you or anyone else incurs as a result of any trading or investment activity that you or anyone else engages in based on any information or material you receive through Aperture or our Website or Services.`,
        type: 'p',
      },
      {
        text: `The Site, Services, and any products and services described on the Site are not available in jurisdictions and/or to clients where the provision or use thereof would not comply with applicable laws, or where Aperture is not authorized to provide such information or services.`,
        type: 'p',
      },
      { text: `7. Duration and Modification`, type: 'subtitle' },
      {
        text: `We reserve the right to change these Terms on a going forward basis at any time. Please check these Terms periodically for changes. Modifications are immediately effective upon publication. We may also elect to notify you of updated Terms through email or as part of recurring billing statements or agreements. If you continue to use the Site or Services after such changes to these Terms are posted, you agree to be bound by the revised Terms. If in the future, you do not agree to be bound by the revised Terms, you must stop using the Site or Services at that time. Aperture reserves the right to modify or discontinue the Site or Services at any time (including by limiting or discontinuing certain features of the Site or Services), temporarily or permanently, without notice to you. Aperture will have no liability for any change to the Site or Services or any suspension or termination of your access to or use of the Site or Services.`,
        type: 'p',
      },
      { text: `Term`, type: 'p' },
      {
        text: `These Terms are effective beginning when you accept the Terms or first access or use the Site, and end when terminated as described in this Section. If you violate any provision of these Terms, your authorization to access the Site and these Terms automatically terminate. In addition, Aperture may, at its sole discretion, terminate these Terms or suspend, throttle your access to or terminate your access, or use of, the Site or Services, at any time for any reason or no reason, with or without notice. Upon termination of these Terms: (a) your license rights will terminate and you must immediately cease all use of the Site or Services; (b) you will no longer be authorized to access your account or the Site or Service.`,
        type: 'p',
      },
      { text: `8. Arbitration; Waiver of Class Action`, type: 'subtitle' },
      {
        text: `8.1 Formal Complaint Process. If you have a dispute with Aperture (a “Complaint”), you agree to contact Aperture through our support team to attempt to resolve any such dispute amicably. If we cannot resolve the dispute through the Aperture support team, you and we agree to use the Formal Complaint Process set forth below. You agree to use this process before filing any arbitration claim or small claims action. If you do not follow the procedures set out in this Section before filing an arbitration claim or suit in small claims court, we shall have the right to ask the arbitrator or small claims court to dismiss your filing unless and until you complete the following steps.`,
        type: 'p',
      },
      {
        text1: `8.2. Procedural Steps. In the event that your dispute with Aperture is not resolved through your contact with Aperture Support, you agree to use our Complaint form to describe your Complaint, how you would like us to resolve the Complaint, and any other information related to your dispute that you believe to be relevant. The Complaint form can be found `,
        link: [
          'https://drive.google.com/file/d/1g_8x079yaeA7zBpChwRPHEL32rPR9qbt/view',
          'here',
        ],
        text2: `or can be requested from Aperture Customer Support. If you would prefer to send a written complaint, please include as much information as possible, including your support case number and any other information related to your dispute that you believe to be relevant, and post to Aperture: 510 E El Camino Real Ste C # 70522 Sunnyvale, CA 94086.`,
        type: 'edit',
      },
      {
        text: `8.3. Aperture Response. We will acknowledge receipt of your Complaint form after you submit it. An Aperture customer relations agent ("Agent") will review your Complaint. The Agent will evaluate your Complaint based on the information you have provided and information in the possession of Aperture. Within 15 business days of our receipt of your Complaint form, the Agent will address the issues raised in your Complaint form by sending you an e-mail ("Resolution Notice") in which the Agent will: (i) offer to resolve your complaint in the way you requested; (ii) make a determination rejecting your Complaint and set out the reasons for the rejection; or (iii) offer to resolve your Complaint with an alternative solution. In exceptional circumstances, if the Agent is unable to respond to your Complaint within 15 business days for reasons beyond Aperture’s control, the Agent will send you a communication indicating the reasons for any delay in answering your Complaint, and specifying the deadline by which the Agent will respond to your Complaint, which will be no later than 35 business days from our receipt of your Complaint form.`,
        type: 'p',
      },
      {
        text: `8.4. Arbitration; Waiver of Class Action. If we cannot resolve the dispute through the Formal Complaint Process, you and we agree that any dispute arising out of or relating to this Agreement or the Aperture Services, including, without limitation, federal and state statutory claims, common law claims, and those based in contract, tort, fraud, misrepresentation, or any other legal theory, shall be resolved through binding arbitration, on an individual basis (the “Arbitration Agreement”). Subject to applicable jurisdictional requirements, you may elect to pursue your claim in your local small claims court rather than through arbitration so long as your matter remains in small claims court and proceeds only on an individual (non-class and non-representative) basis. Arbitration shall be conducted in accordance with the American Arbitration Association's rules for arbitration of consumer-related disputes (accessible at https://www.adr.org/sites/default/files/Consumer%20Rules.pdf).`,
        type: 'p',
      },
      {
        text: `This Arbitration Agreement includes, without limitation, disputes arising out of or related to the interpretation or application of the Arbitration Agreement, including the enforceability, revocability, scope, or validity of the Arbitration Agreement or any portion of the Arbitration Agreement. All such matters shall be decided by an arbitrator and not by a court or judge.`,
        type: 'upper',
      },
      {
        text: `CLASS ACTION WAIVER: TO THE EXTENT PERMISSIBLE BY LAW, ALL CLAIMS MUST BE BROUGHT IN A PARTY’S INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS, COLLECTIVE ACTION, OR REPRESENTATIVE PROCEEDING (COLLECTIVELY “CLASS ACTION WAIVER”). THE ARBITRATOR MAY NOT CONSOLIDATE MORE THAN ONE PERSON'S CLAIMS OR ENGAGE IN ANY CLASS ARBITRATION. YOU ACKNOWLEDGE THAT, BY AGREEING TO THESE TERMS, YOU AND APERTURE ARE EACH WAIVING THE RIGHT TO A TRIAL BY JURY AND THE RIGHT TO PARTICIPATE IN A CLASS ACTION.`,
        type: 'upper',
      },
      {
        text: `The arbitration will be conducted by a single, neutral arbitrator and shall take place in the county or parish in which you reside, or another mutually agreeable location, in the English language. The arbitrator may award any relief that a court of competent jurisdiction could award and the arbitral decision may be enforced in any court. An arbitrator’s decision and judgment thereon will not have a precedential or collateral estoppel effect. At your request, hearings may be conducted in person or by telephone and the arbitrator may provide for submitting and determining motions on briefs, without oral hearings. To the extent permitted by law, the prevailing party in any action or proceeding to enforce this Agreement, any arbitration pursuant to this Agreement, or any small claims action shall be entitled to costs and attorneys' fees. If the arbitrator or arbitration administrator would impose filing fees or other administrative costs on you, we will reimburse you, upon request, to the extent such fees or costs would exceed those that you would otherwise have to pay if you were proceeding instead in a court. We will also pay additional fees or costs if required to do so by the arbitration administrator's rules or applicable law.`,
        type: 'p',
      },
      { text: `9. Miscellaneous`, type: 'subtitle' },
      { text: `General Terms`, type: 'p' },
      {
        text: `These Terms, together with the Privacy Policy and any Additional Terms, are the entire and exclusive understanding and agreement between you and Aperture regarding your use of the Site. You may not assign or transfer these Terms or your rights under these Terms, in whole or in part, by operation of law or otherwise, without our prior written consent. We may assign these Terms at any time without notice or consent. The failure to require performance of any provision will not affect our right to require performance at any other time after that, nor will a waiver by us of any breach or default of these Terms, or any provision of these Terms, be a waiver of any subsequent breach or default or a waiver of the provision itself. Use of section headers in these Terms is for convenience only and will not have any impact on the interpretation of any provision. Throughout these Terms the use of the word "including" means "including but not limited to". If any part of these Terms is held to be invalid or unenforceable, the unenforceable part will be given effect to the greatest extent possible, and the remaining parts will remain in full force and effect.`,
        type: 'p',
      },
      { text: `Governing Law`, type: 'p' },
      {
        text: `These Terms are governed by the laws of Singapore without regard to conflict of law principles. You and Aperture submit to the personal and exclusive jurisdiction of courts in Singapore for resolution of any lawsuit or court proceeding permitted under these Terms. We operate the Site from our offices in Singapore, and we make no representation that Materials included in the Site are appropriate or available for use in other locations.`,
        type: 'p',
      },
      { text: `Privacy Policy`, type: 'p' },
      {
        text: `Please read the Aperture Privacy Policy carefully for information relating to our collection, use, storage, disclosure of your personal information. The Aperture Privacy Policy is incorporated by this reference into, and made a part of, these Terms.`,
        type: 'p',
      },
      { text: `Additional Terms`, type: 'p' },
      {
        text: `Your use of the Site is subject to all additional terms, policies, rules, or guidelines applicable to the Site or certain features of the Site that we may post on or link to from the Site (the "Additional Terms"). All Additional Terms are incorporated by this reference into, and made a part of, these Terms. You agree that no joint venture, partnership, employment or agency relationship exists between you and us a result of these Terms or your use of the Site and the services.`,
        type: 'p',
      },
      { text: `Consent to Electronic Communications`, type: 'p' },
      {
        text: `By using the Site, you consent to receiving certain electronic communications from us. You agree that any notices, agreements, disclosures, or other communications that we send to you electronically will satisfy any legal communication requirements, including that those communications be in writing.`,
        type: 'p',
      },
      { text: `Contact Information`, type: 'p' },
      {
        text: `The Site is offered by Aperture, 510 C East El Camino Real #70522, Sunnyvale, CA 94087. You may contact us by sending correspondence to that address or by emailing us at support@aperture.finance`,
        type: 'p',
      },
      { text: `No Support`, type: 'p' },
      {
        text: `We are under no obligation to provide support for the Site or Services. In instances where we may offer support, the support will be subject to published policies.`,
        type: 'p',
      },
      { text: `Monitoring`, type: 'p' },
      {
        text: `We are under no obligation to monitor the information contained in or transmitted through the Site. You agree that we may monitor on the Site (i) to comply with applicable laws, regulations or other government requests; and (ii) for such other purposes as we deem appropriate. We reserve the right to modify, reject or eliminate any information contained in or transmitted through the Site that we believe is unacceptable or in violation of these Terms.`,
        type: 'p',
      },
      { text: `Eligibility and International Usage`, type: 'p' },
      {
        text: `We make no representation that the Site is appropriate or available for use in any specific country. Access to the Site from countries or territories or by individuals where such access is illegal is prohibited. You are also restricted from using these services if you are an individual that is sanctioned by the Office of Foreign Assets Control (OFAC), or otherwise located in any country, region or jurisdiction sanctioned by OFAC or another U.S. agency. A representative sample of current OFAC countries is listed in Appendix 1.`,
        type: 'p',
      },
      {
        text: `You must be at least 18 years old to use the Site. By agreeing to these Terms, you represent and warrant to us that: (a) you are at least 18 years old; (b) you have not previously been suspended or removed from the Site; and (c) your registration and your use of the Site is in compliance with any and all applicable laws and regulations.`,
        type: 'p',
      },
      { text: `APPENDIX 1: OFAC Excluded Jurisdictions`, type: 'p' },
      {
        text: `OFAC's programs are dynamic, but as of the Current Date, a representative sample of jurisdictions includes:`,
        type: 'p',
      },
      {
        text: [
          { '': 'Balkans' },
          { '': 'Belarus' },
          { '': 'Burma' },
          { '': 'Burundi' },
          { '': 'Central African Republic' },
          { '': 'Congo, Democratic Republic of' },
          { '': 'Crimea region of Ukraine' },
          { '': 'Cuba' },
          { '': 'Iran (Islamic Republic of)' },
          { '': 'Lebanon' },
          { '': 'Libya' },
          { '': 'Mali' },
          { '': 'Nicaragua' },
          { '': 'North Korea (Democratic Republic of Korea)' },
          { '': 'Somalia' },
          { '': 'South Sudan' },
          { '': 'Sudan' },
          { '': 'Syria' },
          { '': 'Ukraine / Russia-related' },
          { '': 'Venezuela' },
          { '': 'Yemen' },
          { '': 'Zimbabwe' },
        ],
        type: 'bullets',
      },
    ],
  },
};
